/*
* Agência Wehsoft Theme
*
* Use this file to add custom Javascript. Keeping your custom
* Javascript in this file will make it easier to update the theme.
*/


(function () {
  // Add custom code below this line

  // Update model size when variant changes
  function initModelSizeUpdater() {
    const sizeSelectors = document.querySelectorAll('.product__selector--size input[type="radio"], .product__selector--size .select-popout__option');
    const modelSizeSpan = document.querySelector('[data-model-size]');

    if (!modelSizeSpan) return;

    // Listen for radio button changes
    sizeSelectors.forEach(function (selector) {
      if (selector.type === 'radio') {
        selector.addEventListener('change', function () {
          if (this.checked) {
            modelSizeSpan.textContent = this.value;
          }
        });
      } else {
        // For dropdown/popout selectors
        selector.addEventListener('click', function (e) {
          e.preventDefault();
          const value = this.getAttribute('data-value');
          if (value) {
            modelSizeSpan.textContent = value;
          }
        });
      }
    });
  }

  // Update discount badge dynamically when variant changes
  function initDiscountBadgeUpdater() {
    // Listen to variant selector changes instead of observing DOM
    const variantSelectors = document.querySelectorAll('[data-single-option-selector]');

    variantSelectors.forEach(function (selector) {
      selector.addEventListener('change', function () {
        // Hide immediately, then check after price updates
        hideDiscountBadge();
        setTimeout(updateDiscountBadge, 50);
      });
    });

    // Also listen for click on variant buttons
    const variantButtons = document.querySelectorAll('.radio__input');
    variantButtons.forEach(function (btn) {
      btn.addEventListener('change', function () {
        // Hide immediately, then check after price updates
        hideDiscountBadge();
        setTimeout(updateDiscountBadge, 50);
      });
    });
  }

  function hideDiscountBadge() {
    const discountWrapper = document.querySelector('.product__price-discount-wrapper');
    const discountBadge = document.querySelector('[data-discount-badge]');

    if (discountWrapper) {
      discountWrapper.style.display = 'none';
    }
    if (discountBadge) {
      discountBadge.style.display = 'none';
    }
  }

  function updateDiscountBadge() {
    const comparePriceEl = document.querySelector('[data-compare-price]');
    const regularPriceEl = document.querySelector('[data-product-price]');
    const discountWrapper = document.querySelector('.product__price-discount-wrapper');
    const discountBadge = document.querySelector('[data-discount-badge]');

    if (!comparePriceEl || !regularPriceEl) return;

    const comparePriceText = comparePriceEl.textContent.trim();
    const regularPriceText = regularPriceEl.textContent.trim();

    // Check if compare price is empty or same as regular
    if (!comparePriceText || comparePriceText === '') {
      // No discount - hide elements
      if (discountWrapper) {
        discountWrapper.style.display = 'none';
      }
      if (discountBadge) {
        discountBadge.style.display = 'none';
      }
      return;
    }

    // Extract numeric values from price strings (handle Brazilian Real format)
    const compareValue = parseFloat(comparePriceText.replace(/[^\d,.-]/g, '').replace('.', '').replace(',', '.')) || 0;
    const regularValue = parseFloat(regularPriceText.replace(/[^\d,.-]/g, '').replace('.', '').replace(',', '.')) || 0;

    if (compareValue && regularValue && compareValue > regularValue) {
      // Calculate discount percentage
      const discountPercent = Math.round(((compareValue - regularValue) / compareValue) * 100);

      // Show discount wrapper and badge
      if (discountWrapper) {
        discountWrapper.style.display = 'flex';
      }
      if (discountBadge) {
        discountBadge.textContent = discountPercent + '% OFF';
        discountBadge.style.display = 'inline-flex';
      }
    } else {
      // No discount - hide elements
      if (discountWrapper) {
        discountWrapper.style.display = 'none';
      }
      if (discountBadge) {
        discountBadge.style.display = 'none';
      }
    }
  }

  // Size Guide Modal functionality
  function initSizeGuideModal() {
    const modal = document.querySelector('[data-size-guide-modal]');
    if (!modal) return;

    const openButtons = document.querySelectorAll('[data-open-size-guide]');
    const closeButtons = modal.querySelectorAll('[data-size-guide-close]');
    const tabs = modal.querySelectorAll('[data-size-guide-tab]');
    const tabContents = modal.querySelectorAll('[data-size-guide-content]');
    const modalImage = modal.querySelector('[data-size-guide-image]');
    const sizeBadge = modal.querySelector('[data-size-guide-size-badge]');
    const sizeInfoText = modal.querySelector('[data-size-guide-info-size]');
    const prevNav = modal.querySelector('[data-size-nav="prev"]');
    const nextNav = modal.querySelector('[data-size-nav="next"]');
    const buttonsContainer = modal.querySelector('[data-size-buttons-container]');

    let currentModalSize = '';
    let productSizes = [];

    // Generate size buttons dynamically from product page
    function generateSizeButtons() {
      if (!buttonsContainer) return;

      // Get sizes from product page radio buttons
      const sizeRadios = document.querySelectorAll('.product__selector--size input[type="radio"]');
      productSizes = [];

      sizeRadios.forEach(function (radio) {
        if (radio.value && productSizes.indexOf(radio.value) === -1) {
          productSizes.push(radio.value);
        }
      });

      // If no sizes found, return
      if (productSizes.length === 0) return;

      // Clear container
      buttonsContainer.innerHTML = '';

      // Get current selected size
      const checkedSize = document.querySelector('.product__selector--size input[type="radio"]:checked');
      currentModalSize = checkedSize ? checkedSize.value : productSizes[0];

      // Create buttons
      productSizes.forEach(function (size, index) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'size-guide-modal__size-btn';
        if (size === currentModalSize) {
          btn.classList.add('size-guide-modal__size-btn--active');
        }
        btn.setAttribute('data-modal-size-btn', size);
        btn.textContent = size;

        // Add click event
        btn.addEventListener('click', function () {
          updateSizeGuideContent(size);
        });

        buttonsContainer.appendChild(btn);
      });
    }

    // Function to update modal image and size badge
    function updateSizeGuideContent(size) {
      if (size) {
        currentModalSize = size;
      } else {
        // Get current selected size from product page
        const checkedSize = document.querySelector('.product__selector--size input[type="radio"]:checked');
        currentModalSize = checkedSize ? checkedSize.value : (productSizes[0] || 'P');
      }

      // Update size badge
      if (sizeBadge) {
        sizeBadge.textContent = currentModalSize;
      }

      // Update info text
      if (sizeInfoText) {
        sizeInfoText.textContent = currentModalSize;
      }

      // Update modal size buttons
      const modalSizeButtons = buttonsContainer.querySelectorAll('[data-modal-size-btn]');
      modalSizeButtons.forEach(function (btn) {
        const btnSize = btn.getAttribute('data-modal-size-btn');
        btn.classList.toggle('size-guide-modal__size-btn--active', btnSize === currentModalSize);
      });

      // Get variant image based on selected size
      if (modalImage) {
        // Try to get variant-specific image from the product gallery
        const variantImage = document.querySelector('[data-product-single-media-wrapper].is-selected img');
        const firstImage = document.querySelector('[data-product-single-media-wrapper] img');
        const productImage = document.querySelector('.product__media img');

        // Use variant image if available, otherwise first product image
        const imageSource = variantImage || firstImage || productImage;

        if (imageSource && imageSource.src) {
          modalImage.src = imageSource.src;
          modalImage.alt = imageSource.alt || 'Modelo usando o produto';
        }
      }
    }

    // Navigation arrows
    function navigateSize(direction) {
      if (productSizes.length === 0) return;

      const currentIndex = productSizes.indexOf(currentModalSize);
      var newIndex;

      if (direction === 'prev') {
        newIndex = currentIndex > 0 ? currentIndex - 1 : productSizes.length - 1;
      } else {
        newIndex = currentIndex < productSizes.length - 1 ? currentIndex + 1 : 0;
      }

      updateSizeGuideContent(productSizes[newIndex]);

      // Scroll button into view
      const activeBtn = modal.querySelector('[data-modal-size-btn="' + productSizes[newIndex] + '"]');
      if (activeBtn && buttonsContainer) {
        activeBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    if (prevNav) {
      prevNav.addEventListener('click', function () {
        navigateSize('prev');
      });
    }

    if (nextNav) {
      nextNav.addEventListener('click', function () {
        navigateSize('next');
      });
    }

    // Open modal
    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        generateSizeButtons();
        updateSizeGuideContent();
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });

    // Close modal
    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });

    // Tab switching
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const targetTab = this.getAttribute('data-size-guide-tab');
        switchToTab(targetTab);
      });
    });

    // Tab switch function
    function switchToTab(targetTab) {
      // Remove active class from all tabs and contents
      tabs.forEach(function (t) {
        t.classList.remove('size-guide-modal__tab--active');
      });
      tabContents.forEach(function (c) {
        c.classList.remove('size-guide-modal__tab-content--active');
      });

      // Add active class to target tab and corresponding content
      const targetTabBtn = modal.querySelector('[data-size-guide-tab="' + targetTab + '"]');
      if (targetTabBtn) {
        targetTabBtn.classList.add('size-guide-modal__tab--active');
      }
      const targetContent = modal.querySelector('[data-size-guide-content="' + targetTab + '"]');
      if (targetContent) {
        targetContent.classList.add('size-guide-modal__tab-content--active');
      }
    }

    // Tab switch buttons (like "Como medir" button)
    const tabSwitchButtons = modal.querySelectorAll('[data-size-guide-tab-switch]');
    tabSwitchButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const targetTab = this.getAttribute('data-size-guide-tab-switch');
        switchToTab(targetTab);
      });
    });

    // Update content when size changes on product page
    const sizeSelectors = document.querySelectorAll('.product__selector--size input[type="radio"]');
    sizeSelectors.forEach(function (selector) {
      selector.addEventListener('change', function () {
        if (modal.classList.contains('is-open')) {
          setTimeout(function () {
            updateSizeGuideContent();
          }, 100);
        }
      });
    });
  }

  // Mobile product image slideshow with navigation arrows
  // Uses IntersectionObserver on parent card to lazy-init when visible
  function initMobileProductSlideshow() {
    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    if (!isTouch || window.innerWidth > 767) return;

    var FlickityClass = window.themeVendor && window.themeVendor.Flickity;
    if (!FlickityClass) return;

    var autoplaySpeed = 2500;
    var sliders = []; // track all initialized sliders for visibility observer

    function initSlider(template) {
      if (template.dataset.initialized) return;
      template.dataset.initialized = 'true';

      var slides = template.content.querySelectorAll('[data-mobile-slide]');
      if (slides.length <= 1) return;

      var holder = document.createElement('div');
      holder.className = 'product__media__slider--mobile';
      holder.appendChild(template.content.cloneNode(true));
      template.parentNode.insertBefore(holder, template);

      var flkty = new FlickityClass(holder, {
        cellSelector: '[data-mobile-slide]',
        contain: true,
        wrapAround: true,
        imagesLoaded: true,
        pageDots: true,
        prevNextButtons: false,
        draggable: false,
        adaptiveHeight: false,
        autoPlay: false,
      });

      var link = holder.closest('a');
      if (link) {
        link.addEventListener('click', function (e) {
          if (e.target.closest('.flickity-button')) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }

      setTimeout(function () { flkty.resize(); }, 300);

      // Track for autoplay on visibility
      var card = holder.closest('[data-product-media-container]');
      if (card) {
        sliders.push({ flkty: flkty, card: card });
        visibilityObserver.observe(card);
      }
    }

    // Auto-slide on visibility disabled to fix navigation issues
    var visibilityObserver = new IntersectionObserver(function (entries) {
      // Autoplay removed - slides only change by manual swipe
    }, { threshold: 0.6 });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var template = entry.target.querySelector('[data-mobile-slideshow-template]');
        if (template) initSlider(template);
      });
    }, { rootMargin: '100px' });

    // Observe existing product cards
    function observeTemplates(root) {
      (root || document).querySelectorAll('[data-mobile-slideshow-template]:not([data-initialized])').forEach(function (tpl) {
        var card = tpl.closest('[data-product-media-container]');
        if (card && !card.dataset.mobileObserved) {
          card.dataset.mobileObserved = 'true';
          observer.observe(card);
        }
      });
    }

    observeTemplates();

    // Watch only related-products sections for dynamically loaded products
    document.querySelectorAll('[data-section-type="related-products"], [data-section-type="recent-products"]').forEach(function (section) {
      new MutationObserver(function () {
        observeTemplates(section);
      }).observe(section, { childList: true, subtree: true });
    });
  }

  // Cart item limit - reads settings from window.cartLimitSettings (set by Liquid)
  var cartLimitActive = true;

  function getCartLimitSettings() {
    var s = window.cartLimitSettings || {};
    return {
      enabled: s.enabled !== false,
      limit: s.limit || 4,
      message: s.message || 'A compra não pode ser concluída pois o carrinho excede o limite de itens permitidos. Remova itens para continuar.',
      keyword: (s.keyword || '').trim(),
      keywordLabel: (s.keywordLabel || s.keyword || '').trim(),
      keywordMax: s.keywordMax || 2,
      keywordMessage: s.keywordMessage || 'A compra não pode ser concluída pois o carrinho excede o limite de ||max|| itens de ||palavra||. Remova itens para continuar.',
      singleCollections: (s.singleCollections || []).filter(function (collection) {
        return (collection.productIds || []).length > 0;
      }),
      singleMessage: s.singleMessage || 'A compra não pode ser concluída pois o carrinho tem mais de um item de ||colecao||. Deixe apenas um para continuar.'
    };
  }

  // Alguma regra de limite ligada? Cada uma vale sozinha, sem depender do limite geral.
  function hasCartLimitRule(cfg) {
    return cfg.enabled || !!cfg.keyword || cfg.singleCollections.length > 0;
  }

  // Limite de 1 item por coleção (ex.: brinco, bolsa, echarpe): quantos itens
  // do carrinho são da coleção (soma as quantidades).
  function cartCollectionCount(cart, collection) {
    return (cart && cart.items ? cart.items : []).reduce(function (sum, item) {
      return collection.productIds.indexOf(item.product_id) !== -1 ? sum + item.quantity : sum;
    }, 0);
  }

  // Primeira coleção com mais de um item no carrinho (ou null)
  function overSingleCollection(cart, cfg) {
    for (var i = 0; i < cfg.singleCollections.length; i++) {
      if (cartCollectionCount(cart, cfg.singleCollections[i]) > 1) return cfg.singleCollections[i];
    }
    return null;
  }

  // Coleção que barra a entrada do produto: ele é dela e já há item dela no
  // carrinho (ou a própria adição traz mais de um). Retorna null se pode entrar.
  function blockedSingleCollection(cart, cfg, productId, quantity) {
    if (!productId) return null;
    for (var i = 0; i < cfg.singleCollections.length; i++) {
      var collection = cfg.singleCollections[i];
      if (collection.productIds.indexOf(productId) === -1) continue;
      if (cartCollectionCount(cart, collection) + (quantity || 1) > 1) return collection;
    }
    return null;
  }

  function singleCollectionMessage(cfg, collection) {
    return cfg.singleMessage.split('||colecao||').join(collection.title || '');
  }

  // "Vestido Longo" e "VESTIDO LONGO" contam como a mesma palavra: comparamos
  // sem acento e em minúsculas, senão "Colã" não casaria com "cola".
  function normalizeText(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  function titleHasKeyword(title, keyword) {
    if (!keyword) return false;
    return normalizeText(title).indexOf(normalizeText(keyword)) !== -1;
  }

  // Quantos itens do carrinho têm a palavra no nome do produto (soma as quantidades)
  function cartKeywordCount(cart, keyword) {
    if (!keyword) return 0;
    return (cart && cart.items ? cart.items : []).reduce(function (sum, item) {
      var title = item.product_title || item.title || '';
      return titleHasKeyword(title, keyword) ? sum + item.quantity : sum;
    }, 0);
  }

  // join(undefined) usa vírgula como separador, então o || '' não é decorativo:
  // sem ele um rótulo ausente viraria uma vírgula solta no meio da frase.
  function keywordLimitMessage(cfg) {
    return cfg.keywordMessage
      .split('||palavra||').join(cfg.keywordLabel || '')
      .split('||max||').join(cfg.keywordMax || '');
  }

  function initCartLimit() {
    var cfg = getCartLimitSettings();
    if (!hasCartLimitRule(cfg)) return;

    // Watch for cart drawer/page updates to toggle limit message vs checkout
    var observer = new MutationObserver(function () {
      checkCartLimitUI();
    });

    var cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }

    var cartPage = document.querySelector('[data-cart-page]');
    if (cartPage) {
      observer.observe(cartPage, { childList: true, subtree: true });
    }

    // Initial check
    checkCartLimitUI();
  }

  function showCartLimitToast(opts) {
    var cfg = getCartLimitSettings();
    // O rótulo é singular, então "N itens de X" e "um X" saem certos sem plural.
    // A cliente não precisa saber que a regra casa por palavra no nome.
    var byKeyword = !!(opts && opts.keyword);
    var byCollection = opts && opts.collection;
    var title = byCollection
      ? 'Limite de 1 item de ' + byCollection.title + ' atingido'
      : byKeyword
        ? 'Limite de ' + cfg.keywordMax + ' itens de ' + cfg.keywordLabel + ' atingido'
        : 'Limite de ' + cfg.limit + ' itens atingido';
    var desc = byCollection
      ? 'Você já tem um item de ' + byCollection.title + ' no carrinho. Remova-o para adicionar outro.'
      : byKeyword
        ? 'Remova um ' + cfg.keywordLabel + ' do carrinho para adicionar outro.'
        : 'Remova um item do carrinho para adicionar outro.';
    var existing = document.querySelector('.cart-limit-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'cart-limit-toast';
    toast.innerHTML =
      '<div class="cart-limit-toast__icon">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<circle cx="12" cy="12" r="10"/>' +
          '<line x1="12" y1="8" x2="12" y2="12"/>' +
          '<line x1="12" y1="16" x2="12.01" y2="16"/>' +
        '</svg>' +
      '</div>' +
      '<div class="cart-limit-toast__content">' +
        '<p class="cart-limit-toast__title"></p>' +
        '<p class="cart-limit-toast__desc"></p>' +
      '</div>' +
      '<button type="button" class="cart-limit-toast__close" aria-label="Fechar">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<line x1="18" y1="6" x2="6" y2="18"/>' +
          '<line x1="6" y1="6" x2="18" y2="18"/>' +
        '</svg>' +
      '</button>' +
      '<div class="cart-limit-toast__progress"></div>';

    // textContent, não innerHTML: a palavra vem de uma config e não é HTML
    toast.querySelector('.cart-limit-toast__title').textContent = title;
    toast.querySelector('.cart-limit-toast__desc').textContent = desc;

    document.body.appendChild(toast);

    var closeBtn = toast.querySelector('.cart-limit-toast__close');
    var hideTimeout, removeTimeout;

    function dismissToast() {
      clearTimeout(hideTimeout);
      clearTimeout(removeTimeout);
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 400);
    }

    closeBtn.addEventListener('click', dismissToast);

    setTimeout(function () { toast.classList.add('is-visible'); }, 10);
    hideTimeout = setTimeout(function () {
      toast.classList.remove('is-visible');
      removeTimeout = setTimeout(function () { toast.remove(); }, 400);
    }, 5000);
  }

  // Portão do checkout: é aqui que o limite de fato vale, porque lê o carrinho
  // pronto (/cart.js já traz product_title) e independe do que a página mostra.
  function checkCartLimitUI() {
    var cfg = getCartLimitSettings();
    if (!hasCartLimitRule(cfg)) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var limitMessages = document.querySelectorAll('[data-cart-limit-message]');
        var checkoutButtons = document.querySelectorAll('[data-cart-checkout-buttons]');

        var overGlobal = cfg.enabled && cart.item_count > cfg.limit;
        var overKeyword = !!cfg.keyword && cartKeywordCount(cart, cfg.keyword) > cfg.keywordMax;
        var overCollection = overSingleCollection(cart, cfg);

        if (overGlobal || overKeyword || overCollection) {
          // O limite geral vem primeiro: é o mais amplo, remover itens resolve os outros
          var text = overGlobal
            ? cfg.message
            : overKeyword ? keywordLimitMessage(cfg) : singleCollectionMessage(cfg, overCollection);
          document.querySelectorAll('[data-cart-limit-text]').forEach(function (el) {
            el.textContent = text;
          });
          limitMessages.forEach(function (el) { el.classList.remove('hidden'); });
          checkoutButtons.forEach(function (el) { el.classList.add('hidden'); });
        } else {
          limitMessages.forEach(function (el) { el.classList.add('hidden'); });
          checkoutButtons.forEach(function (el) { el.classList.remove('hidden'); });
        }
      })
      .catch(function () {});
  }

  // Nome do produto do botão clicado. O tema põe todo [data-add-to-cart] dentro
  // de um {% form 'product' %}, que só carrega o id da variante, daí o atributo
  // explícito. Sem ele a regra por nome não barra aqui, mas o portão do checkout
  // ainda pega, então o pior caso é a cliente descobrir mais tarde.
  function addToCartTitle(btn) {
    var explicit = btn.getAttribute('data-product-title');
    if (explicit) return explicit;

    var holder = btn.closest('[data-section-id]');
    var json = holder && holder.querySelector('[data-product-json]');
    if (!json) return '';
    try {
      return (JSON.parse(json.textContent) || {}).title || '';
    } catch (err) {
      return '';
    }
  }

  // Produto e quantidade do botão clicado, para o limite por coleção. Os botões
  // do tema levam data-product-id; o {% form 'product' %} também traz o
  // product-id escondido, que serve de reserva.
  function addToCartProductId(btn) {
    var explicit = btn.getAttribute('data-product-id');
    if (explicit) return parseInt(explicit, 10);
    var form = btn.closest('form');
    var input = form && form.querySelector('[name="product-id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function addToCartQuantity(btn) {
    var form = btn.closest('form');
    var input = form && (form.querySelector('[name="quantity"][data-quantity-field]') || form.querySelector('[name="quantity"]'));
    var quantity = input ? parseInt(input.value, 10) : 1;
    return quantity > 0 ? quantity : 1;
  }

  // Intercept add-to-cart clicks (capturing phase, before theme handler)
  document.addEventListener('click', function (e) {
    var cfg = getCartLimitSettings();
    if (!hasCartLimitRule(cfg) || !cartLimitActive) return;
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hitGlobal = cfg.enabled && cart.item_count >= cfg.limit;
        // Só barra pela palavra se o item que está entrando também a tiver
        var hitKeyword = !!cfg.keyword &&
          titleHasKeyword(addToCartTitle(btn), cfg.keyword) &&
          cartKeywordCount(cart, cfg.keyword) >= cfg.keywordMax;

        var hitCollection = blockedSingleCollection(cart, cfg, addToCartProductId(btn), addToCartQuantity(btn));

        if (hitGlobal) {
          showCartLimitToast();
        } else if (hitKeyword) {
          showCartLimitToast({ keyword: true });
        } else if (hitCollection) {
          showCartLimitToast({ collection: hitCollection });
        } else {
          cartLimitActive = false;
          btn.click();
          setTimeout(function () { cartLimitActive = true; }, 100);
        }
      })
      .catch(function () {
        cartLimitActive = false;
        btn.click();
        setTimeout(function () { cartLimitActive = true; }, 100);
      });
  }, true);

  // Gift reminder ("Brinde") - reads settings from window.giftReminderSettings (set by Liquid)
  var giftReminderBypass = false;

  function getGiftReminderSettings() {
    return window.giftReminderSettings || { enabled: false };
  }

  // Depois que a cliente recusa o brinde navegando, não exibimos o popup
  // automaticamente de novo nesta sessão (só volta a perguntar no checkout).
  // A recusa do item para chegar ao brinde (etapa 'nudge') tem chave própria:
  // dispensar o brinco não pode calar o popup da bolsa quando ela chegar ao mínimo.
  var GIFT_SUPPRESS_KEY = 'giftAutoSuppressed';
  var GIFT_NUDGE_SUPPRESS_KEY = 'giftNudgeSuppressed';
  var giftAutoSuppressedFallback = {};

  function isGiftAutoSuppressed(key) {
    key = key || GIFT_SUPPRESS_KEY;
    try {
      return sessionStorage.getItem(key) === '1';
    } catch (e) {
      return !!giftAutoSuppressedFallback[key];
    }
  }

  function setGiftAutoSuppressed(value, key) {
    key = key || GIFT_SUPPRESS_KEY;
    giftAutoSuppressedFallback[key] = !!value;
    try {
      if (value) sessionStorage.setItem(key, '1');
      else sessionStorage.removeItem(key);
    } catch (e) {}
  }

  // Coleções que ainda podem ser oferecidas. Cada coleção vira uma linha do popup.
  //
  // 'per_collection' (padrão): a cliente leva um brinde de cada coleção, então só
  // some a linha da coleção que já tem item no carrinho.
  // 'single': ela leva um brinde no total; basta um item de qualquer coleção para
  // que nenhuma linha continue disponível (o popup se encerra na primeira escolha).
  // Coleção já atendida: tem item dela no carrinho. Base de todo o fluxo — decide
  // quais linhas somem, quais aparecem recolhidas e quando parar de oferecer.
  function giftCollectionInCart(collection, cart) {
    var cartProductIds = (cart && cart.items ? cart.items : []).map(function (item) {
      return item.product_id;
    });
    return (collection.productIds || []).some(function (id) {
      return cartProductIds.indexOf(id) !== -1;
    });
  }

  function giftPendingCollections(cart, cfg) {
    var collections = ((cfg && cfg.collections) || []).filter(function (collection) {
      return (collection.productIds || []).length > 0;
    });

    function hasItemFrom(collection) {
      return giftCollectionInCart(collection, cart);
    }

    if (cfg && cfg.selectionMode === 'single') {
      return collections.some(hasItemFrom) ? [] : collections;
    }

    return collections.filter(function (collection) {
      return !hasItemFrom(collection);
    });
  }

  // Índices das coleções que já têm item no carrinho (as linhas "Adicionado").
  function giftAttendedIndexes(cart, cfg) {
    return ((cfg && cfg.collections) || [])
      .filter(function (collection) {
        return giftCollectionInCart(collection, cart);
      })
      .map(function (collection) {
        return String(collection.index);
      });
  }

  // Linhas que o popup exibe. Difere de giftPendingCollections nas coleções com
  // desconto percentual (promoção de acessórios): ali a cliente leva quantos
  // itens quiser, então a linha continua disponível depois de adicionar e o
  // popup só fecha quando ela fecha. No modo 'single' vale o brinde único, ainda
  // que a oferta seja de desconto.
  function giftRowsToShow(cart, cfg) {
    if (cfg && cfg.selectionMode === 'single') return giftPendingCollections(cart, cfg);

    var pendingIndexes = giftPendingCollections(cart, cfg).map(function (collection) {
      return collection.index;
    });

    return ((cfg && cfg.collections) || []).filter(function (collection) {
      if (!(collection.productIds || []).length) return false;
      return collection.repeatable || pendingIndexes.indexOf(collection.index) !== -1;
    });
  }

  // Decide if the gift reminder modal should be shown for the current cart
  function shouldShowGiftReminder(cart, cfg) {
    if (!cfg || !cfg.enabled) return false;
    // Valor mínimo atingido e, se exigido, o item obrigatório no carrinho
    if (!isGiftUnlocked(cart, cfg)) return false;
    // Só exibe se ainda houver coleção disponível para oferecer
    return giftPendingCollections(cart, cfg).length > 0;
  }

  // Item obrigatório (settings.gift_nudge_required): o brinde só vale com um
  // item da coleção oferecida no carrinho (ex.: bolsa só com brinco), mesmo
  // que o valor mínimo já tenha sido atingido por outros itens.
  function giftRequiresNudgeItem(cfg) {
    return !!(cfg && cfg.enabled && cfg.nudge && cfg.nudge.required);
  }

  function giftRequirementMet(cart, cfg) {
    return !giftRequiresNudgeItem(cfg) || cartHasProductFrom(cart, cfg.nudge.productIds);
  }

  // Brinde liberado: valor mínimo atingido e item obrigatório no carrinho.
  // Regra única para popup, cupom, barra de progresso e remoção do brinde.
  function isGiftUnlocked(cart, cfg) {
    return isGiftThresholdReached(cart, cfg && cfg.threshold) && giftRequirementMet(cart, cfg);
  }

  // Item para chegar ao brinde (ex.: brinco para quem tem vestido no carrinho).
  // Abaixo do mínimo, o popup oferece os itens da coleção configurada que fecham
  // a diferença, a preço cheio; adicionado o item, ele passa para o brinde.
  function cartHasProductFrom(cart, productIds) {
    return ((cart && cart.items) || []).some(function (item) {
      return (productIds || []).indexOf(item.product_id) !== -1;
    });
  }

  // Quanto falta para o mínimo do brinde, em centavos
  function giftRemaining(cart, cfg) {
    return Math.max(0, ((cfg && cfg.threshold) || 0) - giftCartValue(cart));
  }

  // Elegível ao item para chegar ao brinde: sem item da coleção oferecida (o
  // limite é 1 por pedido), com algum em estoque que feche o que falta, e:
  // - abaixo do mínimo: com item da coleção que ativa a oferta (ex.: vestido);
  // - mínimo já atingido: só quando o item é obrigatório (é o que falta para o
  //   brinde). Aí vale para qualquer carrinho, senão quem chegou ao valor sem
  //   vestido ficaria sem caminho até a bolsa.
  function giftNudgeEligible(cart, cfg) {
    var nudge = cfg && cfg.enabled ? cfg.nudge : null;
    if (!nudge || !nudge.maxPrice) return false;
    if (cartHasProductFrom(cart, nudge.productIds)) return false;
    var remaining = giftRemaining(cart, cfg);
    if (remaining > nudge.maxPrice) return false;
    if (remaining <= 0) {
      if (!nudge.required) return false;
    } else if (!cartHasProductFrom(cart, nudge.triggerProductIds)) {
      return false;
    }
    return giftPendingCollections(cart, cfg).length > 0;
  }

  // Etapa do popup para o carrinho: 'gift' (escolher o brinde), 'nudge' (item
  // para chegar ao brinde) ou null (nada a oferecer).
  function giftStepFor(cart, cfg) {
    if (shouldShowGiftReminder(cart, cfg)) return 'gift';
    if (giftNudgeEligible(cart, cfg)) return 'nudge';
    return null;
  }

  // Troca o cabeçalho do popup para a etapa. No nudge a mensagem leva o valor
  // que falta, então é refeita a cada abertura.
  function setGiftPopupStep(popup, step, cart) {
    var cfg = getGiftReminderSettings();
    popup._giftStep = step;
    // Classes de layout (assets/custom.css): a etapa do brinco tem diálogo mais
    // largo e o "Agora não" em contorno, exceto quando aberto pelo finalizar.
    // O diálogo largo continua na etapa do brinde que veio dela: sem isso ele
    // encolhia na hora em que a cliente adicionava o item.
    popup.classList.toggle('gift-popup--nudge', step === 'nudge');
    popup.classList.toggle('gift-popup--wide', step === 'nudge' || !!popup._giftNudgeDone);
    popup.classList.toggle('gift-popup--checkout', !!popup._checkoutBtn);
    popup.querySelectorAll('[data-gift-head]').forEach(function (head) {
      head.classList.toggle('hidden', head.getAttribute('data-gift-head') !== step);
    });
    var nudgeText = popup.querySelector('[data-gift-nudge-text]');
    if (nudgeText && cfg.nudge) {
      // Valor já atingido (item obrigatório): "faltam R$ 0,00" não faz sentido
      var remaining = giftRemaining(cart, cfg);
      var template = remaining > 0 ? cfg.nudge.text : cfg.nudge.textReached;
      nudgeText.textContent = (template || '').replace(/\|\|falta\|\|/g, formatBRL(remaining));
      nudgeText.classList.toggle('hidden', !template);
    }

    // Botão de recusa: no finalizar ele segue para o pagamento (openGiftPopup).
    var declineBtn = popup.querySelector('[data-gift-decline]');
    if (declineBtn) {
      if (popup._checkoutBtn) declineBtn.textContent = cfg.checkoutText || 'Continuar para o pagamento';
      else if (step === 'nudge') declineBtn.textContent = (cfg.nudge && cfg.nudge.declineText) || 'Agora não';
      else declineBtn.textContent = cfg.declineText || 'Concluir escolha';
    }
  }

  function getFlickityLib() {
    // O tema expõe o Flickity via themeVendor.Flickity (não window.Flickity).
    return (window.themeVendor && window.themeVendor.Flickity) || window.Flickity;
  }

  // Linha do nudge: só os itens cujo preço fecha o que falta. O Flickity da faixa
  // é desfeito antes, porque ele não lida com células escondidas depois de
  // montado; resetGiftTracks o refaz só com as visíveis.
  // Retorna quantos cards ficaram visíveis.
  function filterGiftNudgeCards(popup, remaining) {
    var row = popup.querySelector('[data-gift-row-index="nudge"]');
    if (!row) return 0;
    var track = row.querySelector('[data-gift-track]');
    var FlickityLib = getFlickityLib();
    var flkty = track && FlickityLib ? FlickityLib.data(track) : null;
    if (flkty) flkty.destroy();

    var shown = 0;
    row.querySelectorAll('[data-gift-card]').forEach(function (card) {
      var fits = (parseInt(card.getAttribute('data-gift-price'), 10) || 0) >= remaining;
      card.classList.toggle('hidden', !fits);
      if (fits) shown++;
    });
    return shown;
  }

  // Linha bloqueada: na etapa 'nudge' o brinde aparece, mas só libera depois
  // do item para chegar ao mínimo. Os botões ficam desativados de verdade, não
  // só no visual.
  function setGiftRowLocked(row, locked) {
    row.classList.toggle('is-locked', locked);
    row.querySelectorAll('[data-gift-add]').forEach(function (btn) {
      btn.disabled = locked;
    });
  }

  // Oculta as linhas que não estão mais disponíveis (ver giftRowsToShow:
  // coleção de brinde já atendida, ou qualquer brinde escolhido no modo 'single';
  // as coleções com desconto continuam abertas para novos itens).
  //
  // Na etapa 'nudge' são dois passos: a linha do item para chegar ao brinde,
  // aberta, e abaixo as linhas do brinde, bloqueadas. Depois que o item entra
  // (popup._giftNudgeDone), a linha dele fica recolhida e marcada como
  // adicionada acima do brinde, já liberado.
  //
  // Retorna quantas linhas de oferta ficaram visíveis (a do item já adicionado
  // não conta: com o brinde escolhido, o fluxo termina).
  function applyGiftRowVisibility(popup, cart, cfg) {
    var rowIndexes = giftRowsToShow(cart, cfg).map(function (collection) {
      return String(collection.index);
    });

    if (popup._giftStep === 'nudge') {
      var cards = filterGiftNudgeCards(popup, giftRemaining(cart, cfg));
      var shown = 0;
      popup.querySelectorAll('[data-gift-row]').forEach(function (row) {
        var isNudge = row.getAttribute('data-gift-row-index') === 'nudge';
        var show = cards > 0 && (isNudge || rowIndexes.indexOf(row.getAttribute('data-gift-row-index')) !== -1);
        row.classList.toggle('hidden', !show);
        row.classList.remove('is-done', 'is-step-done');
        setGiftRowLocked(row, show && !isNudge);
        setGiftRowCollapsed(row, false);
        if (show) shown++;
      });
      popup.classList.toggle('gift-popup--single-row', shown === 1);
      return cards > 0 ? shown : 0;
    }

    var nudgeRow = popup.querySelector('[data-gift-row-index="nudge"]');
    if (nudgeRow) {
      var nudgeDone = !!popup._giftNudgeDone;
      nudgeRow.classList.toggle('hidden', !nudgeDone);
      nudgeRow.classList.toggle('is-step-done', nudgeDone);
      setGiftRowLocked(nudgeRow, false);
      setGiftRowCollapsed(nudgeRow, nudgeDone);
    }

    var attendedIndexes = giftAttendedIndexes(cart, cfg);
    var visible = 0;

    popup.querySelectorAll('[data-gift-row]').forEach(function (row) {
      var index = row.getAttribute('data-gift-row-index');
      if (index === 'nudge') return;
      setGiftRowLocked(row, false);
      var show = rowIndexes.indexOf(index) !== -1;
      row.classList.toggle('hidden', !show);
      if (!show) return;
      visible++;

      // Coleção já atendida (só sobra visível na promoção de acessórios): a linha
      // aparece recolhida e marcada, para a cliente ver de relance o que já
      // escolheu. Se foi ela quem reabriu a linha, deixamos aberta.
      var done = attendedIndexes.indexOf(index) !== -1;
      row.classList.toggle('is-done', done);
      if (!done) delete row.dataset.giftExpanded;
      setGiftRowCollapsed(row, done && row.dataset.giftExpanded !== '1');
    });

    popup.classList.toggle('gift-popup--single-row', visible === 1 && !popup._giftNudgeDone);
    return visible;
  }

  function setGiftRowCollapsed(row, collapsed) {
    row.classList.toggle('is-collapsed', collapsed);
    var toggle = row.querySelector('[data-gift-row-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }

  // Inicializa ou refaz o Flickity em cada track visível do popup.
  // DEVE ser chamada depois que o popup já está visível no DOM com layout calculado.
  // preservePosition: mantém a célula atual (usado após adicionar um item, para
  // não jogar a cliente de volta ao começo da faixa que ela estava percorrendo).
  function resetGiftTracks(popup, preservePosition) {
    if (!popup) return;

    var FlickityLib = getFlickityLib();
    if (!FlickityLib) return;

    popup.querySelectorAll('[data-gift-track]').forEach(function (track) {
      var row = track.closest('[data-gift-row]');
      if (row && (row.classList.contains('hidden') || row.classList.contains('is-collapsed'))) return;

      var flkty = FlickityLib.data(track);
      if (flkty) {
        flkty.resize();
        fitGiftTrackHeight(track);
        if (!preservePosition) flkty.select(0, false, true);
        return;
      }

      // Cards escondidos (linha do nudge, ver filterGiftNudgeCards) ficam fora
      var cards = track.querySelectorAll('[data-gift-card]:not(.hidden)');
      if (cards.length === 0) return;

      new FlickityLib(track, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        wrapAround: false,
        adaptiveHeight: false,
        setGallerySize: false,
        imagesLoaded: true,
        draggable: true,
        dragThreshold: 3,
        cellSelector: '[data-gift-card]:not(.hidden)'
      });

      fitGiftTrackHeight(track);
      FlickityLib.data(track).on('resize', function () {
        fitGiftTrackHeight(track);
      });
    });
  }

  // Com setGallerySize: false a altura da faixa vinha só do CSS (min-height fixo),
  // e no mobile o card é mais alto que isso: o botão "Adicionar" ficava cortado.
  // Mede o card mais alto e aplica a mesma altura aos cards (botões alinhados)
  // e à faixa. A imagem tem aspect-ratio no CSS, então a medida não depende do
  // carregamento dela.
  function fitGiftTrackHeight(track) {
    var viewport = track.querySelector('.flickity-viewport');
    var cards = track.querySelectorAll('[data-gift-card]:not(.hidden)');
    if (!viewport || cards.length === 0) return;

    var tallest = 0;
    cards.forEach(function (card) {
      card.style.height = 'auto';
    });
    cards.forEach(function (card) {
      tallest = Math.max(tallest, card.offsetHeight);
    });
    if (!tallest) return;

    cards.forEach(function (card) {
      card.style.height = tallest + 'px';
    });
    viewport.style.minHeight = '0px';
    viewport.style.height = tallest + 'px';
  }

  // Cupons das coleções atendidas (com item no carrinho), desde que o carrinho
  // tenha atingido o mínimo. Substitui o desconto automático, que não combinava
  // direito entre as coleções: o código é aplicado no carrinho e vai junto para
  // o checkout. A validação final (mínimo, combinações) é do próprio cupom na Shopify.
  function giftDiscountCodesFor(cart, cfg) {
    if (!cfg || !cfg.enabled || !isGiftUnlocked(cart, cfg)) return [];
    var codes = [];
    (cfg.collections || []).forEach(function (collection) {
      var code = collection.discountCode;
      if (code && giftCollectionInCart(collection, cart) && codes.indexOf(code) === -1) {
        codes.push(code);
      }
    });
    return codes;
  }

  function giftCodeIn(codes, code) {
    return codes.some(function (current) {
      return String(current).toLowerCase() === String(code).toLowerCase();
    });
  }

  // Todos os cupons configurados no brinde, tenham ou não item no carrinho
  function allGiftCodes(cfg) {
    return ((cfg && cfg.collections) || [])
      .map(function (collection) { return collection.discountCode; })
      .filter(Boolean);
  }

  function cartCodes(cart) {
    return ((cart && cart.discount_codes) || []).map(function (discount) {
      return discount.code;
    });
  }

  // Ajusta os cupons do brinde no carrinho: tira os que não valem mais (coleção
  // sem item no carrinho, ou carrinho abaixo do mínimo) e, com addMissing, põe os
  // que faltam. Os demais cupons (ex.: VIP) ficam: o parâmetro `discount` do
  // /cart/update.js substitui todos os códigos.
  // Resolve com o carrinho atualizado (ou como estava, se o update falhar).
  function syncGiftDiscountCodes(cart, addMissing) {
    var cfg = getGiftReminderSettings();
    var wanted = giftDiscountCodesFor(cart, cfg);
    var configured = allGiftCodes(cfg);
    var current = cartCodes(cart);
    var next = current.filter(function (code) {
      return !giftCodeIn(configured, code) || giftCodeIn(wanted, code);
    });
    if (addMissing) {
      wanted.forEach(function (code) {
        if (!giftCodeIn(next, code)) next.push(code);
      });
    }
    if (next.join(',') === current.join(',')) return Promise.resolve(cart);

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: next.join(',') })
    })
      .then(function (r) { return r.json(); })
      // Erro no update (cupom inválido etc.): segue com o carrinho como estava
      .then(function (updated) { return updated && updated.items ? updated : cart; });
  }

  // Aplica os cupons do brinde no carrinho. Nunca rejeita: se falhar, o checkout
  // segue sem o cupom. Resolve com o carrinho atualizado (ou null, se não deu
  // para ler).
  function applyGiftDiscountCodes() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return syncGiftDiscountCodes(cart, true); })
      .catch(function () { return null; });
  }

  // Cupons do brinde que deveriam valer e a Shopify não aplicou (cupom ausente
  // ou marcado como não aplicável). Com algum assim, o brinde sairia cobrado.
  function giftCodesNotApplied(cart, cfg) {
    var applied = ((cart && cart.discount_codes) || [])
      .filter(function (discount) { return discount.applicable !== false; })
      .map(function (discount) { return discount.code; });
    return giftDiscountCodesFor(cart, cfg).filter(function (code) {
      return !giftCodeIn(applied, code);
    });
  }

  // Linha de brinde: o popup marca o item com esta propriedade ao adicionar (o
  // "_" a esconde do carrinho e do checkout). Brinde adicionado antes da marca
  // existir é reconhecido por ser de coleção de item grátis e sair a R$ 0.
  var GIFT_LINE_PROPERTY = '_brinde';

  function isGiftLine(item, cfg) {
    if (item.properties && item.properties[GIFT_LINE_PROPERTY]) return true;
    if (item.final_line_price !== 0) return false;
    return ((cfg && cfg.collections) || []).some(function (collection) {
      return !collection.repeatable && (collection.productIds || []).indexOf(item.product_id) !== -1;
    });
  }

  // Coleção de brinde grátis (um por pedido) a que a linha pertence, ou null
  // (ex.: promoção de acessórios, em que ela leva quantos quiser).
  function giftLineCollection(item, cfg) {
    var found = null;
    ((cfg && cfg.collections) || []).some(function (collection) {
      if (collection.repeatable || (collection.productIds || []).indexOf(item.product_id) === -1) return false;
      found = collection;
      return true;
    });
    return found;
  }

  // Valida o brinde no carrinho a cada página carregada, a cada mudança do
  // carrinho e no finalizar. O carrinho pode ser mexido por fora do popup (outra
  // aba, quantidade alterada, link direto), então nada do que o popup garantiu
  // ao adicionar é tomado como certo:
  // - brinde bloqueado (abaixo do mínimo ou sem o item obrigatório, ex.: tirou o
  //   brinco): o brinde e o cupom dele saem juntos, senão a bolsa iria cobrada;
  // - brinde liberado: no máximo 1 unidade de cada, e um só no total no modo
  //   "apenas um brinde" (o cupom não limita quantidade);
  // - cupom de brinde que sobrou sem o item sai.
  // Só remove: pôr cupom fica com o popup e com o finalizar, assim uma falha da
  // Shopify ao aceitar o código não vira um ciclo de tentativas a cada evento.
  // Enquanto o popup adiciona algo (setGiftPopupBusy), é ele quem conduz.
  var giftGuard = null;
  // Quando a validação mexeu no carrinho por último (o re-render dela chega
  // depois): a camada de "Removendo item…" espera por ele.
  var giftCartChangedAt = 0;

  function enforceGiftCart() {
    var cfg = getGiftReminderSettings();
    if (!cfg.enabled) return Promise.resolve(null);
    var popup = getGiftPopup();
    if (popup && popup._giftBusy) return Promise.resolve(null);
    if (giftGuard) return giftGuard;

    giftGuard = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codesBefore = cartCodes(cart).join(',');
        var updates = {};
        var removed = 0;
        var trimmed = 0;
        var belowMinimum = !isGiftThresholdReached(cart, cfg.threshold);
        if (!isGiftUnlocked(cart, cfg)) {
          (cart.items || []).forEach(function (item) {
            if (!isGiftLine(item, cfg)) return;
            updates[item.key] = 0;
            removed++;
          });
        } else {
          var kept = {};
          (cart.items || []).forEach(function (item) {
            if (!isGiftLine(item, cfg)) return;
            var collection = giftLineCollection(item, cfg);
            if (!collection) return;
            var slot = cfg.selectionMode === 'single' ? 'single' : String(collection.index);
            if (kept[slot]) {
              updates[item.key] = 0;
              trimmed++;
              return;
            }
            kept[slot] = true;
            if (item.quantity > 1) {
              updates[item.key] = 1;
              trimmed++;
            }
          });
        }

        var step = removed || trimmed
          ? fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: updates })
            })
              .then(function (r) { return r.json(); })
              .then(function (updated) {
                if (!updated || !updated.items) return Promise.reject('remove-failed');
                return updated;
              })
          : Promise.resolve(cart);

        return step
          .then(function (current) { return syncGiftDiscountCodes(current, false); })
          .then(function (synced) {
            if (removed || trimmed || cartCodes(synced).join(',') !== codesBefore) {
              giftCartChangedAt = Date.now();
              refreshThemeCart();
            }
            if (removed) {
              showGiftNotice(belowMinimum || !cfg.nudge
                ? 'O brinde saiu do carrinho: o valor ficou abaixo de ' + formatBRL(cfg.threshold) + '.'
                : (cfg.nudge.removedText || 'O brinde saiu do carrinho.'));
            } else if (trimmed) {
              showGiftNotice('O brinde é de 1 unidade por pedido: ajustamos o seu carrinho.');
            }
            return synced;
          });
      })
      .catch(function () { return null; })
      .then(function (cart) {
        giftGuard = null;
        return cart;
      });
    return giftGuard;
  }

  // Let the original checkout proceed (re-click the button while bypassing the interceptor)
  function proceedToCheckout(btn) {
    btn.setAttribute('aria-busy', 'true');
    enforceGiftCart().then(applyGiftDiscountCodes).then(function () {
      btn.removeAttribute('aria-busy');
      giftReminderBypass = true;
      btn.click();
      setTimeout(function () { giftReminderBypass = false; }, 100);
    });
  }

  // Refresh the theme cart drawer/page after an AJAX change
  function refreshThemeCart() {
    try {
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('theme:cart:update'));
  }

  // Format cents as BRL (loja em Real)
  function formatBRL(cents) {
    return (Math.max(0, cents) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  // Brief notice toast (ex.: ainda falta valor para o brinde)
  function showGiftNotice(message) {
    var existing = document.querySelector('.gift-notice-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'gift-notice-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 350);
    }, 4000);
  }

  // Valor base do carrinho para o brinde: subtotal dos itens, menos os itens das
  // coleções excluídas (ex.: Flash Sale), que não contam para ganhar o brinde.
  function giftCartValue(cart) {
    if (!cart) return 0;
    var subtotal = (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) || 0;
    var excluded = getGiftReminderSettings().excludedProductIds || [];
    if (!excluded.length) return subtotal;
    (cart.items || []).forEach(function (item) {
      if (excluded.indexOf(item.product_id) === -1) return;
      subtotal -= (item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
    });
    return Math.max(0, subtotal);
  }

  // O carrinho tem algum item das coleções excluídas? Aí a barra do brinde some do
  // carrinho lateral.
  function giftCartHasExcluded(cart) {
    var excluded = getGiftReminderSettings().excludedProductIds || [];
    if (!excluded.length) return false;
    return ((cart && cart.items) || []).some(function (item) {
      return excluded.indexOf(item.product_id) !== -1;
    });
  }

  // Cart reached the gift minimum value? (threshold em centavos, base no subtotal)
  function isGiftThresholdReached(cart, threshold) {
    return giftCartValue(cart) >= (threshold || 0);
  }

  // Aviso para quem tenta pegar o brinde ainda bloqueado: falta valor ou falta
  // o item obrigatório.
  function giftLockedMessage(cart, cfg) {
    if (!isGiftThresholdReached(cart, cfg.threshold)) {
      return 'Adicione mais ' + formatBRL(cfg.threshold - giftCartValue(cart)) + ' para liberar ' + (cfg.offerLabel || 'o brinde') + '.';
    }
    return (cfg.nudge && cfg.nudge.progressText) || 'Adicione o item da promoção para liberar o brinde.';
  }

  // Add a variant to the cart, then refresh and close the popup.
  // Verifica a elegibilidade (valor mínimo) antes de adicionar.
  function addGiftToCart(variantId, popup, addBtn) {
    if (!variantId) return;
    var cfg = getGiftReminderSettings();
    var threshold = cfg.threshold || 0;
    var originalText = addBtn ? addBtn.textContent : '';
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = '...'; }

    function restore() {
      if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalText; }
    }

    // Popup segue aberto (promoção de acessórios): confirma no próprio botão,
    // senão nada indica que o item entrou no carrinho. Quando a linha se recolhe
    // depois de adicionar, quem confirma é o "Adicionado ✓" do cabeçalho — aí o
    // botão está escondido e só precisa voltar ao estado normal.
    function confirmAdded() {
      if (!addBtn) return;
      if (addBtn.offsetParent === null) {
        restore();
        return;
      }
      addBtn.textContent = cfg.addedText || 'Adicionado ✓';
      addBtn.classList.add('is-added');
      setTimeout(function () {
        addBtn.classList.remove('is-added');
        restore();
      }, 1600);
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var card = addBtn && addBtn.closest('[data-gift-card]');

        // Etapa do item para chegar ao brinde: o carrinho pode ter mudado desde
        // que o popup abriu (outra aba, por exemplo), então a oferta é conferida
        // de novo, e a variante escolhida precisa fechar o que falta.
        if (popup && popup._giftStep === 'nudge') {
          if (!giftNudgeEligible(cart, cfg)) {
            restore();
            closeGiftPopup(popup);
            showGiftNotice('Esta oferta não vale mais para o seu carrinho.');
            return Promise.reject('nudge-not-eligible');
          }
          if (giftVariantPrice(card) < giftRemaining(cart, cfg)) {
            restore();
            showGiftNotice('Esta opção não completa o valor do brinde. Escolha outra.');
            return Promise.reject('nudge-too-cheap');
          }
        } else if (!isGiftUnlocked(cart, cfg)) {
          restore();
          showGiftNotice(giftLockedMessage(cart, cfg));
          return Promise.reject('not-eligible');
        }
        // O popup adiciona direto pelo /cart/add.js, sem passar pelo interceptor
        // do botão de comprar, então o limite de 1 item por coleção é checado aqui.
        var productId = card ? parseInt(card.getAttribute('data-gift-product-id'), 10) : null;
        var limitCollection = blockedSingleCollection(cart, getCartLimitSettings(), productId, 1);
        if (limitCollection) {
          restore();
          showGiftNotice('Você já tem um item de ' + limitCollection.title + ' no carrinho. O limite é de 1 por pedido.');
          return Promise.reject('collection-limit');
        }
        return doGiftAdd(variantId, popup, { restore: restore, added: confirmAdded });
      })
      .catch(function () { restore(); });
  }

  // Fim do fluxo: não sobrou coleção para oferecer. Veio do finalizar, segue
  // para o pagamento; veio sozinho, só mostra o carrinho.
  function finishGiftPopup(popup) {
    var checkoutBtn = popup._checkoutBtn;
    closeGiftPopup(popup);
    if (checkoutBtn) {
      proceedToCheckout(checkoutBtn);
    } else {
      document.dispatchEvent(new CustomEvent('theme:cart:open'));
    }
  }

  // Adiciona sem fechar o popup: a linha da coleção atendida some e a cliente
  // segue escolhendo. Só quando não sobra nenhuma é que o fluxo termina — no
  // modo 'single' isso acontece logo na primeira escolha, e nas coleções com
  // desconto (acessórios) nunca, porque ali ela pode levar quantos quiser.
  //
  // Tudo em sequência, com o popup travado do começo ao fim (setGiftPopupBusy):
  // adicionar, aplicar o cupom, conferir que a Shopify aceitou o cupom e só
  // então atualizar o carrinho. Se o cupom não entrar, o brinde sai de novo:
  // brinde no carrinho sem cupom é bolsa cobrada no pagamento.
  //
  // Na etapa 'nudge' o item vai a preço cheio, sem marca nem cupom, e o popup
  // segue para o brinde (advanceGiftFromNudge).
  function doGiftAdd(variantId, popup, handlers) {
    handlers = handlers || {};
    var cfg = getGiftReminderSettings();
    var nudgeStep = popup._giftStep === 'nudge';
    var line = { id: parseInt(variantId, 10), quantity: 1 };
    if (!nudgeStep) {
      line.properties = {};
      line.properties[GIFT_LINE_PROPERTY] = 'Sim';
    }
    var addedLine = null;

    setGiftPopupBusy(popup, true, 'Adicionando item ao carrinho…');
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [line] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Com o popup aberto depois de adicionar, uma falha silenciosa (item
        // esgotado, por exemplo) pareceria que o botão não fez nada.
        if (data && data.status && data.status !== 200) {
          showGiftNotice(data.description || data.message || 'Não foi possível adicionar este item.');
          return Promise.reject('add-failed');
        }
        addedLine = data && data.items && data.items[0];
        if (nudgeStep) {
          setGiftPopupStatus(popup, 'Liberando seu brinde…');
          return fetchCart();
        }
        setGiftPopupStatus(popup, 'Ativando a promoção…');
        return applyGiftDiscountCodes().then(function (cart) { return cart || fetchCart(); });
      })
      .then(function (cart) {
        if (nudgeStep || !giftCodesNotApplied(cart, cfg).length) return cart;
        return undoGiftAdd(addedLine).then(function () {
          showGiftNotice('Não foi possível aplicar o brinde agora. Tente novamente.');
          return Promise.reject('code-not-applied');
        });
      })
      .then(function (cart) {
        // Item e cupom no carrinho: agora sim atualiza contador e carrinho
        // lateral em segundo plano, sem abrir nada por cima do popup.
        refreshThemeCart();
        setGiftPopupBusy(popup, false);

        if (nudgeStep) {
          advanceGiftFromNudge(popup, cart);
          if (handlers.restore) handlers.restore();
          return;
        }

        var remaining = applyGiftRowVisibility(popup, cart, cfg);
        if (remaining === 0) {
          finishGiftPopup(popup);
          if (handlers.restore) handlers.restore();
          return;
        }
        // Alguma linha pode ter sumido: remede as faixas sem tirar a cliente do
        // ponto em que ela estava.
        resetGiftTracks(popup, true);
        if (handlers.added) handlers.added();
        else if (handlers.restore) handlers.restore();
      })
      .catch(function () {
        // O carrinho pode ter mudado no meio (item adicionado e desfeito)
        refreshThemeCart();
        setGiftPopupBusy(popup, false);
        if (handlers.restore) handlers.restore();
      });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // Desfaz a adição de uma unidade (a linha pode já ter outras) e tira o cupom
  // que tiver ficado sem o item. Nunca rejeita.
  function undoGiftAdd(addedLine) {
    if (!addedLine || !addedLine.key) return Promise.resolve();
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: addedLine.key, quantity: Math.max(0, (addedLine.quantity || 1) - 1) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.items) return syncGiftDiscountCodes(cart, false);
      })
      .catch(function () {});
  }

  // Item para chegar ao brinde adicionado: o mesmo popup passa para a etapa do
  // brinde. Se o carrinho não chegou ao mínimo (mudou no meio), encerra.
  function advanceGiftFromNudge(popup, cart) {
    var cfg = getGiftReminderSettings();
    if (giftStepFor(cart, cfg) !== 'gift') {
      finishGiftPopup(popup);
      return;
    }
    // O popup automático conta esta abertura: fechar sem escolher não o faz
    // reabrir sozinho na próxima mudança do carrinho.
    giftAutoShown = 'gift';
    popup._giftNudgeDone = true;
    // Trava a altura atual: a linha do item recolhe e a do brinde cresce, e o
    // diálogo pulava de tamanho no meio da escolha. Solta ao abrir/fechar.
    var dialog = popup.querySelector('.gift-popup__dialog');
    if (dialog) dialog.style.minHeight = dialog.offsetHeight + 'px';
    setGiftPopupStep(popup, 'gift', cart);
    popup.querySelectorAll('[data-gift-row]').forEach(function (row) {
      delete row.dataset.giftExpanded;
    });
    if (applyGiftRowVisibility(popup, cart, cfg) === 0) {
      finishGiftPopup(popup);
      return;
    }
    expandFirstGiftRow(popup);
    var rows = popup.querySelector('[data-gift-rows]');
    if (rows) rows.scrollTop = 0;
    requestAnimationFrame(function () { resetGiftTracks(popup); });
  }

  // Todas as coleções já atendidas: o popup ficaria só com cabeçalhos recolhidos.
  // Abre a primeira, para ela ver produtos assim que o popup aparece.
  function expandFirstGiftRow(popup) {
    var openRows = [].filter.call(popup.querySelectorAll('[data-gift-row]'), function (row) {
      return !row.classList.contains('hidden');
    });
    if (openRows.length && openRows.every(function (row) { return row.classList.contains('is-collapsed'); })) {
      openRows[0].dataset.giftExpanded = '1';
      setGiftRowCollapsed(openRows[0], false);
    }
  }

  // Preço da variante escolhida no card, em centavos
  function giftVariantPrice(card) {
    var input = card && card.querySelector('[data-gift-variant]');
    if (!input) return 0;
    var source = input.tagName === 'SELECT' ? input.options[input.selectedIndex] : input;
    return parseInt(source && source.getAttribute('data-price'), 10) || 0;
  }

  // Trava o popup enquanto adiciona o item e aplica o cupom: nenhum clique
  // (outro card, fechar, seguir para o pagamento) passa até terminar.
  // A camada de status (data-gift-status) cobre o diálogo e diz em que passo
  // está, senão a espera parece travamento.
  function setGiftPopupBusy(popup, busy, message) {
    if (!popup) return;
    popup._giftBusy = busy;
    if (busy) popup.setAttribute('aria-busy', 'true');
    else popup.removeAttribute('aria-busy');
    if (busy) setGiftPopupStatus(popup, message || '');
  }

  function setGiftPopupStatus(popup, message) {
    var text = popup && popup.querySelector('[data-gift-status-text]');
    if (text) text.textContent = message;
  }

  function getGiftPopup() {
    return document.querySelector('[data-gift-popup]');
  }

  // Trava de rolagem: o tema usa a lib scroll-lock pelos eventos theme:scroll:lock
  // e theme:scroll:unlock. Mexer no overflow do body à mão soltava a trava que o
  // carrinho lateral já tinha posto, então a página de trás voltava a rolar ao
  // fechar o popup. Passando a área de produtos no detail, a lib a registra como
  // rolável e o touchmove dentro dela deixa de ser cancelado no celular.
  function lockGiftScroll(popup) {
    var rows = popup.querySelector('[data-gift-rows]') || popup;
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: rows }));
  }

  // O tema só destrava de fato se nenhum carrinho/quick view estiver aberto, então
  // fechar o popup por cima do carrinho lateral mantém a trava dele intacta.
  function unlockGiftScroll() {
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  }

  function closeGiftPopup(popup) {
    popup = popup || getGiftPopup();
    if (!popup) return;
    popup.classList.remove('is-visible');
    unlockGiftScroll();
    setTimeout(function () { popup.setAttribute('hidden', ''); }, 300);
  }

  var giftPopupBound = false;

  // Wire up the popup events once
  function bindGiftPopup() {
    var popup = getGiftPopup();
    if (!popup || giftPopupBound) return;
    giftPopupBound = true;

    popup.addEventListener('click', function (e) {
      if (popup._giftBusy) {
        e.preventDefault();
        return;
      }
      if (e.target.closest('[data-gift-popup-close]')) {
        closeGiftPopup(popup);
        return;
      }
      var addBtn = e.target.closest('[data-gift-add]');
      // Brinde bloqueado (etapa 'nudge'): só libera depois do item
      if (addBtn && (addBtn.disabled || addBtn.closest('.is-locked'))) return;
      if (addBtn) {
        // Cada card tem seu botão: a variante sai do próprio card
        var card = addBtn.closest('[data-gift-card]');
        var variantInput = card ? card.querySelector('[data-gift-variant]') : null;
        addGiftToCart(variantInput ? variantInput.value : null, popup, addBtn);
        return;
      }
      // Cabeçalho da linha: reabre a coleção já atendida (ou recolhe de novo).
      var rowToggle = e.target.closest('[data-gift-row-toggle]');
      if (rowToggle) {
        var toggleRow = rowToggle.closest('[data-gift-row]');
        // Só as linhas já atendidas recolhem: nas demais o cabeçalho é só título,
        // e esconder os produtos sem a seta de volta deixaria a cliente sem saída.
        if (toggleRow && toggleRow.classList.contains('is-done')) {
          var willCollapse = !toggleRow.classList.contains('is-collapsed');
          setGiftRowCollapsed(toggleRow, willCollapse);
          if (willCollapse) delete toggleRow.dataset.giftExpanded;
          else {
            // Reaberta pela cliente: não recolher de novo sozinho, e medir a
            // faixa agora que ela voltou a ter largura.
            toggleRow.dataset.giftExpanded = '1';
            requestAnimationFrame(function () { resetGiftTracks(popup, true); });
          }
        }
        return;
      }

      var declineBtn = e.target.closest('[data-gift-decline]');
      if (declineBtn) {
        var checkoutBtn = popup._checkoutBtn;
        closeGiftPopup(popup);
        if (checkoutBtn) {
          proceedToCheckout(checkoutBtn);
        } else {
          // Recusou durante a navegação: não exibir automaticamente de novo.
          // Dispensar o item para chegar ao brinde não cala o popup do brinde.
          setGiftAutoSuppressed(true, popup._giftStep === 'nudge' ? GIFT_NUDGE_SUPPRESS_KEY : GIFT_SUPPRESS_KEY);
        }
        return;
      }
    });

    // Swap the product image when the variant (color) changes
    popup.addEventListener('change', function (e) {
      var select = e.target.closest('[data-gift-variant]');
      if (!select || select.tagName !== 'SELECT') return;
      var card = select.closest('[data-gift-card]');
      var img = card ? card.querySelector('[data-gift-image]') : null;
      var opt = select.options[select.selectedIndex];
      var src = opt ? opt.getAttribute('data-image') : null;
      if (img && src) {
        img.removeAttribute('srcset');
        img.src = src;
      }
    });
  }

  // Open the popup. opts.checkoutBtn -> opened from the checkout flow (shows "decline" link)
  // opts.cart -> carrinho atual, usado para ocultar as linhas já atendidas.
  // opts.step -> 'gift' ou 'nudge' (item para chegar ao brinde); sem ele, sai
  // do carrinho (giftStepFor).
  function openGiftPopup(opts) {
    opts = opts || {};
    var popup = getGiftPopup();
    if (!popup) return false;
    bindGiftPopup();
    var cfg = getGiftReminderSettings();

    // Cada abertura recomeça do estado padrão: o que ela reabriu na visita
    // anterior ao popup não fica aberto para sempre.
    popup.querySelectorAll('[data-gift-row]').forEach(function (row) {
      delete row.dataset.giftExpanded;
    });

    // O botão de recusa faz duas coisas: aberto no checkout ele segue para o
    // pagamento, aberto sozinho ele só fecha. O texto acompanha, senão a cliente
    // não descobre por onde pagar e abandona a compra.
    popup._checkoutBtn = opts.checkoutBtn || null;
    popup._giftNudgeDone = false;
    var dialog = popup.querySelector('.gift-popup__dialog');
    if (dialog) dialog.style.minHeight = '';
    setGiftPopupStep(popup, opts.step || giftStepFor(opts.cart, cfg) || 'gift', opts.cart);

    // Sem nenhuma linha para mostrar (ex.: coleção sem produtos disponíveis),
    // o popup não abre e o checkout segue normalmente.
    if (applyGiftRowVisibility(popup, opts.cart, cfg) === 0) return false;

    expandFirstGiftRow(popup);

    popup.removeAttribute('hidden');
    lockGiftScroll(popup);

    // Adiciona a classe depois de um frame para garantir que o display:none foi removido
    // e o layout já existe, só então inicializa o Flickity com tamanhos corretos.
    requestAnimationFrame(function () {
      popup.classList.add('is-visible');

      // iOS Safari exige que o elemento de scroll receba foco programático para
      // ativar scroll sem precisar de um toque. tabindex="-1" no HTML permite isso.
      var rows = popup.querySelector('[data-gift-rows]');
      if (rows) rows.focus({ preventScroll: true });

      // Aguarda a transição CSS do modal (300ms) antes de medir as células
      setTimeout(function () {
        resetGiftTracks(popup);
      }, 320);
    });
    return true;
  }

  // Auto-show the popup when the cart reaches the threshold (once per "qualification").
  // Guarda a etapa já exibida ('gift' ou 'nudge'): passar do brinco à bolsa é
  // uma nova oferta e abre de novo; a mesma etapa, não.
  var giftAutoShown = false;

  // O popup só abre sozinho quando o carrinho muda. Abrir o site, trocar de página
  // ou abrir o drawer com o carrinho igual não abre de novo. A assinatura do último
  // carrinho visto fica na sessão; sem ela (primeira página da sessão) só registramos.
  var GIFT_CART_SIGNATURE_KEY = 'giftCartSignature';
  var giftCartSignatureFallback = null;

  // Só itens e quantidades: cupom aplicado ou removido (ex.: VIP, assets/vip-pricing.js)
  // muda o total mas não é a cliente alterando o carrinho.
  function giftCartSignature(cart) {
    var items = (cart.items || []).map(function (item) {
      return item.key + ':' + item.quantity;
    });
    return items.sort().join('|');
  }

  function getStoredGiftCartSignature() {
    try {
      return sessionStorage.getItem(GIFT_CART_SIGNATURE_KEY);
    } catch (e) {
      return giftCartSignatureFallback;
    }
  }

  function storeGiftCartSignature(signature) {
    giftCartSignatureFallback = signature;
    try {
      sessionStorage.setItem(GIFT_CART_SIGNATURE_KEY, signature);
    } catch (e) {}
  }

  function checkGiftAutoShow() {
    var cfg = getGiftReminderSettings();
    if (!cfg.enabled) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Registra a assinatura mesmo quando não vai abrir, senão uma mudança
        // ignorada agora contaria como "carrinho alterado" na próxima página.
        var previousSignature = getStoredGiftCartSignature();
        var signature = giftCartSignature(cart);
        storeGiftCartSignature(signature);

        // Gatilho configurado como "somente ao finalizar": não abre automaticamente.
        if (cfg.popupTrigger === 'checkout') return;
        // Já recusou nesta sessão: não exibe mais automaticamente (só no checkout)
        if (isGiftAutoSuppressed()) return;

        var step = giftStepFor(cart, cfg);
        if (step === 'nudge' && isGiftAutoSuppressed(GIFT_NUDGE_SUPPRESS_KEY)) step = null;
        // Reset the trigger once it's no longer eligible (gift added or below value)
        if (!step) {
          giftAutoShown = false;
          return;
        }

        var cartChanged = previousSignature !== null && previousSignature !== signature;
        var popup = getGiftPopup();
        var popupOpen = popup && !popup.hasAttribute('hidden');
        if (cartChanged && giftAutoShown !== step && !popupOpen) {
          giftAutoShown = step;
          openGiftPopup({ cart: cart, step: step });
        }
      })
      .catch(function () {});
  }

  function initGiftReminder() {
    var cfg = getGiftReminderSettings();
    if (!cfg.enabled) return;
    bindGiftPopup();

    // A cada mudança: primeiro tira o brinde que não vale mais (enforceGiftCart),
    // depois decide se o popup abre. Nessa ordem, o popup nunca lê um carrinho
    // que está para mudar.
    function runGiftChecks() {
      enforceGiftCart().then(checkGiftAutoShow);
    }

    // Re-check whenever the cart changes
    ['theme:cart:added', 'theme:cart:update', 'theme:cart:loaded', 'theme:cart:open', 'ajaxify:updated']
      .forEach(function (evt) {
        document.addEventListener(evt, function () { setTimeout(runGiftChecks, 150); });
      });

    // Checagem inicial: só abre se o carrinho mudou desde a última página
    // (ex.: produto adicionado por um formulário sem AJAX). Abrir o site não abre.
    runGiftChecks();
  }

  // Intercept checkout button clicks (capturing phase, before form submit)
  document.addEventListener('click', function (e) {
    var cfg = getGiftReminderSettings();
    if (!cfg.enabled || giftReminderBypass) return;

    var btn = e.target.closest('button[name="checkout"]');
    if (!btn) return;
    // Only intercept the standard checkout button inside the cart form
    if (!btn.closest('[data-cart-form]')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var step = giftStepFor(cart, cfg);
        if (step && openGiftPopup({ checkoutBtn: btn, cart: cart, step: step })) {
          // popup shown; wait for user choice
        } else {
          proceedToCheckout(btn);
        }
      })
      .catch(function () {
        proceedToCheckout(btn);
      });
  }, true);

  // Carousel for any gift-progress widget (PDP, product block or cart drawer).
  // Uses event delegation so it also works after the cart drawer re-renders.
  function moveGiftProgressSlide(slider, dir) {
    var slides = slider.querySelectorAll('[data-gift-progress-slide]');
    if (slides.length < 2) return;
    var currentIndex = 0;
    slides.forEach(function (s, i) { if (!s.classList.contains('hidden')) currentIndex = i; });
    var next = ((currentIndex + dir) % slides.length + slides.length) % slides.length;
    slides.forEach(function (s, i) { s.classList.toggle('hidden', i !== next); });
  }

  var giftProgressCarouselBound = false;
  function bindGiftProgressCarousel() {
    if (giftProgressCarouselBound) return;
    giftProgressCarouselBound = true;
    document.addEventListener('click', function (e) {
      // "Adicionar": só libera se o carrinho atingiu o valor mínimo do brinde.
      var openBtn = e.target.closest('[data-gift-open-popup]');
      if (openBtn) {
        e.preventDefault();
        var widget = openBtn.closest('.gift-progress');
        var threshold = parseInt((widget && widget.getAttribute('data-gift-threshold')) || 0, 10);
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var giftCfg = getGiftReminderSettings();
            if (!isGiftUnlocked(cart, giftCfg)) {
              // Falta o item (valor ou item obrigatório) e há um que resolve: oferece
              if (giftNudgeEligible(cart, giftCfg)) {
                openGiftPopup({ cart: cart, step: 'nudge' });
                return;
              }
              showGiftNotice(giftLockedMessage(cart, giftCfg));
              return;
            }
            if (!openGiftPopup({ cart: cart })) {
              var slide = widget && (widget.querySelector('[data-gift-progress-slide]:not(.hidden)') || widget.querySelector('[data-gift-progress-slide]'));
              var link = slide && slide.querySelector('a[href]');
              if (link) window.location.href = link.getAttribute('href');
            }
          })
          .catch(function () { openGiftPopup({}); });
        return;
      }
      var prev = e.target.closest('[data-gift-progress-prev]');
      var next = e.target.closest('[data-gift-progress-next]');
      if (!prev && !next) return;
      var slider = (prev || next).closest('.gift-progress__slider');
      if (slider) moveGiftProgressSlide(slider, prev ? -1 : 1);
    });
  }

  // Gift progress bar on the product page ("quanto falta para o brinde")
  function initGiftProgress() {
    bindGiftProgressCarousel();

    function update() {
      // Re-consulta os widgets a cada atualização (o drawer é re-renderizado/clonado)
      var widgets = document.querySelectorAll('[data-gift-progress]');
      if (!widgets.length) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          widgets.forEach(function (widget) { applyGiftProgress(widget, cart); });
        })
        .catch(function () {});
    }

    // Aplica os valores no widget; só escreve quando muda (evita loop no observer)
    function applyGiftProgress(widget, cart) {
      var threshold = parseInt(widget.getAttribute('data-gift-threshold'), 10) || 0;
      if (!threshold) return;

      // Esconde se o brinde já está no carrinho; no drawer (compact) também esconde
      // quando o carrinho está vazio ou tem algum item da coleção excluída. Na promoção de acessórios (desconto
      // percentual) a barra fica: é por ela que a cliente reabre o popup para
      // escolher mais itens.
      var ids = (widget.getAttribute('data-gift-product-ids') || '')
        .split(',').map(function (n) { return parseInt(n, 10); }).filter(Boolean);
      var repeatable = widget.getAttribute('data-gift-repeatable') === 'true';
      var giftInCart = !repeatable && (cart.items || []).some(function (item) {
        return ids.indexOf(item.product_id) !== -1;
      });
      var isCompact = widget.classList.contains('gift-progress--compact');
      var hide = giftInCart || (isCompact && ((cart.item_count || 0) === 0 || giftCartHasExcluded(cart)));
      var displayVal = hide ? 'none' : '';
      if (widget.style.display !== displayVal) widget.style.display = displayVal;
      if (hide) return;

      var subtotal = giftCartValue(cart);
      var percent = Math.min(100, Math.round((subtotal / threshold) * 100));
      var fill = widget.querySelector('[data-gift-progress-fill]');
      if (fill && fill.style.width !== percent + '%') fill.style.width = percent + '%';

      // Liberado = valor mínimo e, se exigido, o item obrigatório no carrinho.
      // Sem ele, a barra chama para o item e o botão abre o popup nessa etapa.
      var nudgeCfg = getGiftReminderSettings();
      var reached = subtotal >= threshold && giftRequirementMet(cart, nudgeCfg);
      var nudge = !reached && giftNudgeEligible(cart, nudgeCfg);
      var missingItem = !reached && subtotal >= threshold && !!nudgeCfg.nudge;

      var heading = widget.querySelector('[data-gift-progress-heading]');
      if (heading) {
        var success = heading.getAttribute('data-success');
        var newText;
        if (reached && success) {
          newText = success;
        } else if ((nudge || missingItem) && nudgeCfg.nudge.progressText) {
          newText = nudgeCfg.nudge.progressText;
        } else {
          var tpl = heading.getAttribute('data-template') || '';
          newText = tpl.replace(/\|\|falta\|\|/g, formatBRL(threshold - subtotal));
        }
        if (heading.textContent !== newText) heading.textContent = newText;
        widget.classList.toggle('is-complete', reached && !!success);
      }

      // "Adicionar" só fica habilitado quando o valor mínimo foi atingido (ou
      // quando há o item para chegar ao brinde a oferecer)
      var addBtn = widget.querySelector('.gift-progress__add');
      if (addBtn) {
        var enabled = reached || nudge;
        if (addBtn.disabled !== !enabled) addBtn.disabled = !enabled;
        addBtn.classList.toggle('is-disabled', !enabled);
      }
    }

    var updateTimer;
    function scheduleUpdate() {
      clearTimeout(updateTimer);
      updateTimer = setTimeout(update, 120);
    }

    ['theme:cart:added', 'theme:cart:update', 'theme:cart:loaded', 'theme:cart:open', 'ajaxify:updated']
      .forEach(function (evt) {
        document.addEventListener(evt, scheduleUpdate);
      });

    // O tema repopula o drawer a partir do template (HTML do carregamento da página).
    // Observamos o drawer e recalculamos sempre que o conteúdo muda.
    var cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      new MutationObserver(scheduleUpdate).observe(cartDrawer, { childList: true, subtree: true });
    }

    update();
  }

  // Remover item do carrinho: uma camada "Removendo item…" cobre o carrinho e
  // só sai quando ele terminar de recalcular. Remover dispara uma cadeia: o tema
  // refaz o carrinho, a validação do brinde pode tirar a bolsa e o cupom
  // (enforceGiftCart) e o VIP ajusta o cupom dele (assets/vip-pricing.js), cada
  // passo com seu próprio re-render. Sem a camada, a cliente via valores
  // intermediários e podia clicar em finalizar no meio do caminho.
  //
  // "Terminou" = nenhum evento de carrinho por CART_SETTLE_MS e a validação do
  // brinde sem nada a mudar. Se o tema nem chegar a atualizar (erro), a camada
  // sai depois de CART_FIRST_EVENT_MS; e nunca fica mais que CART_BUSY_MAX_MS.
  var CART_SETTLE_MS = 700;
  var CART_FIRST_EVENT_MS = 4000;
  var CART_BUSY_MAX_MS = 12000;
  var cartBusy = null;

  function cartBusyHost() {
    // Carrinho lateral aberto: a camada vai dentro dele (o transform do drawer
    // faz o position: fixed valer só para a área dele). Na página do carrinho,
    // cobre a página.
    var drawer = document.getElementById('cart-drawer');
    if (drawer && document.body.classList.contains('js-drawer-open-cart')) return drawer;
    return document.body;
  }

  function showCartBusy(message) {
    var host = cartBusyHost();
    var overlay = document.querySelector('[data-cart-busy]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'cart-busy';
      overlay.setAttribute('data-cart-busy', '');
      overlay.setAttribute('role', 'status');
      overlay.setAttribute('aria-live', 'polite');
      overlay.innerHTML = '<span class="cart-busy__spinner" aria-hidden="true"></span><p class="cart-busy__text" data-cart-busy-text></p>';
    }
    // O drawer é re-renderizado a cada passo: recoloca a camada se ela saiu
    if (overlay.parentNode !== host) host.appendChild(overlay);
    overlay.classList.toggle('cart-busy--page', host === document.body);
    overlay.querySelector('[data-cart-busy-text]').textContent = message;
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
  }

  function hideCartBusy() {
    var overlay = document.querySelector('[data-cart-busy]');
    if (cartBusy) {
      clearTimeout(cartBusy.settleTimer);
      clearTimeout(cartBusy.maxTimer);
      cartBusy = null;
    }
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    setTimeout(function () {
      if (!cartBusy && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 250);
  }

  // Agenda a checagem de fim. Cada evento de carrinho empurra o prazo.
  function scheduleCartSettle(delay) {
    if (!cartBusy) return;
    clearTimeout(cartBusy.settleTimer);
    cartBusy.settleTimer = setTimeout(function () {
      if (!cartBusy) return;
      // A validação do brinde pode ainda ter algo a tirar: se mudar o carrinho,
      // ela mesma dispara o re-render, que gera evento e adia o fim de novo.
      enforceGiftCart().then(function () {
        if (!cartBusy) return;
        // A validação acabou de mexer no carrinho: o re-render dela ainda vem
        if (giftCartChangedAt > cartBusy.lastEvent) {
          cartBusy.lastEvent = Date.now();
          showCartBusy('Atualizando o carrinho…');
          scheduleCartSettle(CART_SETTLE_MS);
          return;
        }
        if (Date.now() - cartBusy.lastEvent >= CART_SETTLE_MS) hideCartBusy();
      });
    }, delay);
  }

  function initCartBusyOverlay() {
    // Captura: roda antes do handler do tema, que é quem de fato remove
    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-item-remove]');
      if (!removeBtn || removeBtn.classList.contains('is-disabled')) return;
      if (cartBusy) {
        // Já recalculando: segura o clique até terminar
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      cartBusy = { lastEvent: Date.now(), settleTimer: null, maxTimer: setTimeout(hideCartBusy, CART_BUSY_MAX_MS) };
      showCartBusy('Removendo item…');
      scheduleCartSettle(CART_FIRST_EVENT_MS);
    }, true);

    ['theme:cart:added', 'theme:cart:update', 'theme:cart:loaded', 'ajaxify:updated'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        if (!cartBusy) return;
        cartBusy.lastEvent = Date.now();
        showCartBusy('Atualizando o carrinho…');
        scheduleCartSettle(CART_SETTLE_MS);
      });
    });
  }

  // Update PIX price (and the installment: data-installments = máx. de parcelas, data-installment-min = parcela mínima) when variant changes
  function initPixPriceUpdater() {
    var pixPriceEl = document.querySelector('.product__pix-price-value');
    if (!pixPriceEl) return;

    var regularPriceEl = document.querySelector('[data-product-price]');
    if (!regularPriceEl) return;

    var pixContainer = document.querySelector('.product__pix-price[data-pix-discount]');
    var pixDiscount = pixContainer ? parseFloat(pixContainer.getAttribute('data-pix-discount')) : 3;
    var pixMultiplier = (100 - pixDiscount) / 100;

    function updatePixPrice() {
      var priceText = regularPriceEl.textContent.trim();
      var priceValue = parseFloat(priceText.replace(/[^\d,.-]/g, '').replace('.', '').replace(',', '.')) || 0;
      if (priceValue > 0) {
        var pixPrice = priceValue * pixMultiplier;
        var formatted = pixPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        pixPriceEl.textContent = formatted;

        var installmentTextEl = document.querySelector('[data-installment-text]');
        if (installmentTextEl) {
          // Nº de parcelas limitado pela parcela mínima (data-installment-min, em R$)
          var maxInstallments = parseInt(installmentTextEl.getAttribute('data-installments'), 10) || 6;
          var minInstallment = parseFloat(installmentTextEl.getAttribute('data-installment-min')) || 0;
          var installments = maxInstallments;
          if (minInstallment > 0) {
            installments = Math.min(maxInstallments, Math.floor(priceValue / minInstallment));
          }
          installments = Math.max(installments, 1);

          var countEl = installmentTextEl.querySelector('[data-installment-count]');
          var installmentEl = installmentTextEl.querySelector('[data-installment-price]');
          if (countEl) countEl.textContent = installments;
          if (installmentEl) {
            installmentEl.textContent = (priceValue / installments).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
          }
          installmentTextEl.hidden = installments < 2;
        }
      }
    }

    // Observe price element for changes (theme updates it on variant change)
    var observer = new MutationObserver(function () {
      setTimeout(updatePixPrice, 60);
    });
    observer.observe(regularPriceEl, { childList: true, characterData: true, subtree: true });
  }

  // Care accordion - open/close based on viewport
  function initCareAccordion() {
    var accordion = document.querySelector('[data-care-accordion]');
    if (!accordion) return;

    var openDesktop = accordion.getAttribute('data-open-desktop') === 'true';
    var openMobile = accordion.getAttribute('data-open-mobile') === 'true';
    var isMobile = window.innerWidth < 768;

    accordion.open = isMobile ? openMobile : openDesktop;
  }

  // How to Measure Modal
  function initHowToMeasureModal() {
    var modal = document.querySelector('[data-how-to-measure-modal]');
    if (!modal) return;

    var openBtns = document.querySelectorAll('[data-open-how-to-measure]');
    var closeBtns = modal.querySelectorAll('[data-how-to-measure-close]');
    var video = modal.querySelector('[data-how-to-measure-video]');

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (video) { video.pause(); video.currentTime = 0; }
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (video) video.play();
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  // Barras fixas do topo (announcement bar + contagem da promoção).
  // Mede as alturas e publica em CSS vars para o custom.css posicionar
  // a barra de promoção abaixo da announcement bar e o header sticky abaixo das duas.
  function initTopBars() {
    var root = document.documentElement;

    function measure() {
      var announcement = document.querySelector('.announcement-bar-static');
      var promo = document.querySelector('.shopify-section--promo-countdown-bar');
      // Math.floor: a altura da announcement bar é fracionada (calc em rem); arredondar
      // pra cima deixava uma fresta de subpixel entre as duas faixas no mobile.
      var announcementHeight = announcement ? Math.floor(announcement.getBoundingClientRect().height) : 0;
      var promoHeight = promo ? Math.floor(promo.getBoundingClientRect().height) : 0;

      root.style.setProperty('--announcement-bar-height', announcementHeight + 'px');
      root.style.setProperty('--top-bars-height', announcementHeight + promoHeight + 'px');
    }

    var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;

    function observe() {
      if (!resizeObserver) return;
      // observar o mesmo elemento de novo é no-op, então pode repetir com segurança
      document.querySelectorAll('.announcement-bar-static, .shopify-section--promo-countdown-bar').forEach(function (el) {
        resizeObserver.observe(el);
      });
    }

    measure();
    observe();

    // Seções adicionadas/removidas (fim da contagem, editor do tema)
    new MutationObserver(function () {
      measure();
      observe();
    }).observe(document.body, { childList: true });

    document.addEventListener('theme:resize', measure);
    document.addEventListener('theme:parallax:refresh', measure);
    window.addEventListener('load', measure);
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initModelSizeUpdater();
      initDiscountBadgeUpdater();
      initPixPriceUpdater();
      initSizeGuideModal();
      initHowToMeasureModal();
      initCareAccordion();
      initCartLimit();
      initGiftReminder();
      initGiftProgress();
      initCartBusyOverlay();
      initTopBars();
    });
  } else {
    initModelSizeUpdater();
    initDiscountBadgeUpdater();
    initPixPriceUpdater();
    initSizeGuideModal();
    initHowToMeasureModal();
    initCareAccordion();
    initCartLimit();
    initGiftReminder();
    initGiftProgress();
    initCartBusyOverlay();
    initTopBars();
  }

})();
